import gaEvent, { fieldTouchHistory } from 'utilities/tracking'
import {
  GA_ACTION_COMPLETED,
  GA_ACTION_SKIPPED,
} from './constants'

/**
 * Record an event for input fields and optionally track timing and also count towards
 * form abandonment
 * @param {String} label
 * @param {String} action
 * @param {String} category
 * @param {Number} elapsedTime
 */
export const sendEvent = (label, action, category, value, elapsedTime, non_interaction = true) => {
  // Record the event
  gaEvent(action, {
    event_category: category,
    event_label: label,
    value,
    non_interaction,
  })

  // Store in history for form abandonment event
  if (action === GA_ACTION_COMPLETED) {
    fieldTouchHistory.push(label)
  }

  // Prefilled fields will have no elapsed time, so we should not record
  // timings
  if (elapsedTime && elapsedTime < 1800000 && action === GA_ACTION_COMPLETED) {
    // Record the time spent in the field
    gaEvent('timing_complete', {
      event_category: category,
      event_label: label,
      name: 'Time in field',
      value: elapsedTime,
    })
  }
}

export const getAction = value => (
  (value.length || value === true || value === 'true')
    ? GA_ACTION_COMPLETED
    : GA_ACTION_SKIPPED
)
export const getValue = input => input.value || input.checked
export const handleTrackingOnBlur = (e, category, startTime) => {
  const name = e.target.name || e.target.id
  const value = getValue(e.target)
  const action = getAction(value)

  // Only track elapsed time if we're given a start time
  const elapsedTime = startTime ? new Date().getTime() - startTime : undefined

  const trackedCompleted = e.target.getAttribute('data-completed') === 'true' || false
  const trackedSkipped = e.target.getAttribute('data-skipped') === 'true' || false

  if (!trackedCompleted && action === GA_ACTION_COMPLETED) {
    sendEvent(name, action, category, undefined, elapsedTime)
    e.target.setAttribute('data-completed', true)
  } else if (!trackedSkipped && !trackedCompleted) {
    e.target.setAttribute('data-skipped', true)
    sendEvent(name, action, category, undefined, elapsedTime)
  }
}
export const handleTrackingOnChange = (e, category, startTime) => {
  const name = e.target.name || e.target.id
  const value = getValue(e.target)
  const action = getAction(value)

  // Only track elapsed time if we're given a start time
  const elapsedTime = startTime ? new Date().getTime() - startTime : undefined

  const trackedCompleted = e.target.getAttribute('data-completed') === 'true' || false

  if (!trackedCompleted && action === GA_ACTION_COMPLETED) {
    sendEvent(name, action, category, undefined, elapsedTime)
    e.target.setAttribute('data-completed', true)
  }
}



// WEBPACK FOOTER //
// ./hoc/WithInputAnalytics/utils.js